export const BASEURL = process.env.API_ENDPOINT || ''
